/*
 * @Autor: suhang
 * @Date: 2022-05-17 15:42:30
 * @LastEditors: suhang
 * @LastEditTime: 2022-05-18 14:16:08
 * @Description:
 */
import "lib-flexible"
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { i18n } from "./i18n/index"

createApp(App).use(store).use(i18n).use(router).mount("#app")
